import type { NavLink } from '@/types'

export const HUB_LINKS: NavLink[] = [
    { label: 'Cosmetic Dentistry', href: '/cosmetic-dentistry' },
    { label: 'Dental Health', href: '/dental-health' },
    { label: 'General Dentistry', href: '/general-dentistry' }
]

export const MAIN_NAV: NavLink[] = [
    ...HUB_LINKS,
    { label: 'Tools', href: '/tools' },
    { label: 'About', href: '/about' }
]

export const FOOTER_EXPLORE: NavLink[] = [
    { label: 'Home', href: '/' },
    { label: 'Dental tools', href: '/tools' },
    { label: 'About', href: '/about' },
    { label: 'Privacy & Cookie Policy', href: '/privacy' }
]
